import { type ReactNode, useRef, useState } from 'react';
import { CredentialCanvas } from './CredentialCanvas';
import { LandingBackground } from './LandingBackground';
import { LandingLogo } from './LandingLogo';
import { ShareButton } from './ShareButton';
import type { BackgroundItem, ExportArtItem, ShareConfig } from './types';

// The Next shell loads the canvas through `next/dynamic(..., { ssr: false })`. Inertia
// pages only ever render in the browser, so the import is direct.
export function CredentialShell({
  face,
  backgroundItems,
  city,
  dateRange,
  handle,
  selectedWord,
  share,
  exportArt,
}: {
  face: ReactNode;
  backgroundItems: BackgroundItem[];
  city: string;
  dateRange: string;
  handle: string;
  selectedWord: 'seleccionado' | 'seleccionada';
  share: ShareConfig;
  exportArt?: ExportArtItem[];
}) {
  const [dragging, setDragging] = useState(false);
  const eventSourceRef = useRef<HTMLElement>(null);

  return (
    <main
      ref={eventSourceRef}
      className="relative h-dvh w-dvw overflow-hidden bg-black"
    >
      <LandingBackground
        items={backgroundItems}
        interactionsDisabled={dragging}
      />
      <div className="pointer-events-none absolute inset-0 z-30">
        <CredentialCanvas
          face={face}
          eventSource={eventSourceRef}
          onDraggingChange={setDragging}
        />
      </div>
      <LandingLogo city={city} dateRange={dateRange} />
      <ShareButton
        face={face}
        handle={handle}
        selectedWord={selectedWord}
        share={share}
        exportArt={exportArt}
      />
    </main>
  );
}
